import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  roles: [],
  permissions: [],
  isAuthenticated: false,
};

export function decodeJWT(token) {
  try {
    // Split the JWT into its parts
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    // Decode Base64
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Invalid token format:", error);
    return null;
  }
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload;

      // Decode the token to extract roles and permissions
      const decodedToken = decodeJWT(accessToken);
      const { roles = [], permissions = [] } = decodedToken;

      state.user = user;
      state.token = accessToken;
      state.roles = roles;
      state.permissions = permissions;
      state.isAuthenticated = true;

      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("roles", JSON.stringify(roles));
      localStorage.setItem("permissions", JSON.stringify(permissions));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.roles = [];
      state.permissions = [];
      state.isAuthenticated = false;

      // Remove from localStorage
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("roles");
      localStorage.removeItem("permissions");
      localStorage.removeItem("language");
      // Also clear the JWT mirror cookie (used by nginx-proxy for
      // Grafana SSO + SQLAdmin auto-login).
      document.cookie = "access_token=; path=/; max-age=0";
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectRoles = (state) => state.auth.roles;
export const selectPermissions = (state) => state.auth.permissions;
